import { Component, OnInit } from '@angular/core';
import {ActionColumn, ActionItem, ImageColumn, TextColumn} from '../../../../shared/Models/columns';
import {Helper} from '../../../../helpers/helper.service';
import {Grid} from '../../../../shared/Models/grid';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-language-list',
  templateUrl: './language-list.component.html',
  styleUrls: ['./language-list.component.scss']
})
export class LanguageListComponent implements OnInit {
  public grid: Grid;

  constructor(private languageService: LanguageService, private router: Router) { }

  ngOnInit() {
    this.grid = <Grid>{
      root: 'languages',
      columns: [
        <TextColumn>{
          name: 'admin.localization.language.overview.table.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'admin.localization.language.overview.table.locale',
          prop: 'locale',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            < ActionItem > {
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('/back-office/localization/languages/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.languageService,
      rememberURL: this.router.url,
      method: 'list',
      defaultSort: 'name',
      defaultSortType: 'desc'
    };
  }

}
